import {mapActions, mapGetters} from "vuex";

export let manageUserDatas = {
	props: {
		source: {
			type: String,
			required: false
		},
		guideTempProfile: {
			type: Object,
			required: false
		},
		displayMessage: Boolean
	},

	created() {
		this.messageDisplay = this.displayMessage;
		// Si le composant est utilisé dans le guide :
		// Si l'utilisateur n'a encore rien choisi, on initie tempProfile avec un estimated_level de -1
		// Si la propriété existe déjà dans le prop guideTempProfile, on initie tempProfile avec
		if(this.source === "guide") {
			this.tempProfile = Object.assign({}, this.guideTempProfile);
		}
		else {
			this.tempProfile = Object.assign({}, this.profile.datas);
		}

	},

	computed: {
		...mapGetters('global', [
			'profile'
		])
	},

	methods: {
		...mapActions('global', [
			'update_userDatas'
		]),

		saveChanges: function() {
			if(this.source === "guide") {
				this.$emit('profileChanged', this.tempProfile)
			}
			else {
				this.patchUserInfo()
			}
		},

		changedTempProfile: function(attributes) {

			/*
			if(this.source === "guide") {
				let changed = false
				attributes.forEach(element => {
					if(this.guideTempProfile[element] != this.tempProfile[element]) {
						changed = true
					}
				})

				this.saveInactive = changed
			}
			else {
				let changed = false
				attributes.forEach(element => {
					if(this.profile.datas[element] != this.tempProfile[element]) {
						changed = true
					}
				})

				this.saveInactive = changed

			}*/
			//this.saveInactive = false
		},
	},


	data() {
		return {
			tempProfile: {},
			saveInactive: true,
			hasChanged: false,
		}
	}
}